import {Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {map, takeUntil} from "rxjs/operators";
import {ChartComponent} from "ng-apexcharts";
import {ChartOptions, ChartOptionsArea} from "../mis-education/mis-education.component";
import {Observable, Subject} from "rxjs";
import {Centre} from "../../../interfaces/Centres";
import {CentreService} from "../../../services/centre.service";
import {
  AttemptedDonationModel
} from "../../Donationt/manual-attempted-donation-reciept/manual-attempted-donation-reciept.component";
import {DonationService} from "../../Donationt/donation.service";
import {LoadingService} from "../../../services/loading.service";

@Component({
  selector: 'app-mis-donation',
  templateUrl: './mis-donation.component.html',
  styleUrls: ['./mis-donation.component.scss']
})
export class MisDonationComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  latestDonors : any [] =[];
  @ViewChild("areaChart") areaChart!: ChartComponent;
  @ViewChild("barChart") barChart!: ChartComponent;
  public chartOptionsArea: ChartOptionsArea;
  public donationChartOptions: ChartOptions ;

  isSeniorTeacher = true; // or false for testing
  selectedCentre = '';
  centres$: Observable<Centre[]>;
  allowedCentres$ :Observable<Centre[]>;
  startDate: Date | null = null;
  endDate: Date | null = null;
  displayedColumns: string[] = ['sr', 'title', 'message', 'date', 'status'];
  latestDonor?: AttemptedDonationModel;

  attemptedDonations : any = 0;
  teacherAttempts = 39;
  volunteerAttempts = 15;

  totalDonationAmount :any; // in INR

  failedDonations:any;
  successfulDonations :any;

  customCampaigns : any;
  pendingCampaigns = 7;
  doneCampaigns = 5;

  currentYear = new Date().getFullYear();
  lastYear = this.currentYear - 1;
  chartTitle = `Donation ${this.lastYear} vs ${this.currentYear}`;


  notifications = [
    { title: 'Admission Alert', message: 'New student admitted', date: new Date(), status: 'Unread' },
    { title: 'Discharge Notice', message: '2 students discharged', date: new Date(), status: 'Read' },
    { title: 'Session Reminder', message: 'Group session at 5 PM', date: new Date(), status: 'Unread' },
  ];
  constructor(private afs : AngularFirestore,
  private centerService : CentreService,
              public loader : LoadingService,
              private donationService : DonationService) {
    this.centres$ = this.centerService.getAllCentres()
    this.allowedCentres$ = this.centerService.getAllCentres();
    this.chartOptionsArea = {} as ChartOptionsArea;
    this.donationChartOptions = {} as ChartOptions;

  }

  ngOnInit(): void {
    this.loadLatestDonors();
    this.donationService.getAttemptedDonationsCountFromServer().then(count => this.attemptedDonations = count);
    this.donationService.getTotalAttemptedAmount().pipe(takeUntil(this._destroyed$)).subscribe(amount => this.totalDonationAmount = amount);
    this.donationService.getFailedDonationsCountFromServer().then(count => this.failedDonations = count);
    this.donationService.getSuccessDonationCountFromServer().then(count => this.successfulDonations = count);
    this.donationService.getCustomCampaignCountFromServer().then(count => this.customCampaigns = count);
    this.loadDonationsChart();
    this.loadDonationsYearlyComparison();
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  loadLatestDonors() {
    this.afs.collection(this.env.donations, ref =>
      ref.orderBy('createdAt', 'desc').limit(5)
    )
      .valueChanges()
      .pipe(
        map((donations: any[]) => donations.map(d => ({
          donated_by: d.donated_by,
          email: d.email,
          mobile: d.mobile,
          donation_amount: d.donation_amount,
          description: d.description,
          createdAt: new Date(d.createdAt)
        }))),
        takeUntil(this._destroyed$)
      )
      .subscribe(data => {
        this.latestDonors = data;
        this.totalDonationAmount = data.reduce(
          (sum, d) => sum + Number(d.donation_amount), 0
        );
      });
  }

  loadDonationsChart() {
    this.donationService.getDonationsByMonth().pipe(takeUntil(this._destroyed$)).subscribe(data => {
      const categories = Object.keys(data);   // Months
      const values = Object.values(data);     // Amounts
      this.donationChartOptions = {
        series: [{ name: "Donation", data: values }],
        chart: { type: "bar", height: 350, toolbar: { show: true } },
        dataLabels: { enabled: false },
        stroke: { show: false },
        xaxis: { categories, title: { text: "Month" } },
        yaxis: { title: { text: "Donation Amount (₹)" }, min: 0 },
        colors: ["#6973c6"],
        fill: { type: "solid" },
        legend: { position: "top", horizontalAlign: "center" },
        grid: {
          borderColor: "#9aa0ac",
          row: { colors: ["#f5f6fa", "transparent"], opacity: 0.5 }
        },
        tooltip: { enabled: true },
        plotOptions: { bar: { horizontal: false, columnWidth: "50%" } }
      };
    });
  }
  loadDonationsYearlyComparison() {
    const currentYear = new Date().getFullYear();
    const lastYear = currentYear - 1;
    this.donationService.getDonationsByYear(lastYear).pipe(takeUntil(this._destroyed$)).subscribe(lastYearData => {
      this.donationService.getDonationsByYear(currentYear).pipe(takeUntil(this._destroyed$)).subscribe(currentYearData => {

        // Ensure months are consistent (Jan–Dec)
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        this.chartOptionsArea = {
          series: [
            { name: `${lastYear}`, data: months.map(m => lastYearData[m] || 0) },
            { name: `${currentYear}`, data: months.map(m => currentYearData[m] || 0) }
          ],
          chart: { type: "area", height: 350, toolbar: { show: false } },
          dataLabels: { enabled: false },
          stroke: { curve: "smooth", width: 3 },
          xaxis: { categories: months },
          yaxis: { title: { text: "Donations (₹)" } },
          colors: ["#fc8380", "#6973c6"],
          fill: { type: "gradient" },
          legend: { position: "top", horizontalAlign: "left" }
        };
      });
    });
  }
}
